module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-02-20bb7bf7bac02942803f8b7663273ad6.jpg";